const NAME = "COMMUNICATION_CLASSIFICATION";

export default NAME;
